module.exports = __webpack_public_path__ + "static/owanari-2f71471d098272ad57bde9d0e56459ad.png";